import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { RegularButton } from "components/Button";
import { ReactComponent as CallIcon } from "assets/icons/call.svg";
import { ReactComponent as BuildingIcon } from "assets/icons/building.svg";
import { ReactComponent as AppointmentIcon } from "assets/icons/appointment.svg";
import PhoneNumbersList from "./PhoneNumbersList";
import AddressesList from "./AddressesList";
import Appointments from "./Appointments";

type SelectedIcon = "call" | "building" | "appointment";

const ADD_BUTTON_LABEL_KEYS: Record<SelectedIcon, string> = {
  call: "clinics.detail.addPhoneNumber",
  building: "clinics.detail.addAddress",
  appointment: "clinics.detail.addAppointment",
};

const TABS: Array<{
  key: SelectedIcon;
  label: string;
  Icon: React.FC<{ className?: string }>;
}> = [
  { key: "call", label: "Phone numbers", Icon: CallIcon },
  { key: "building", label: "Addresses", Icon: BuildingIcon },
  { key: "appointment", label: "Appointments", Icon: AppointmentIcon },
];

type Props = { orgId: number };

const DetailSelector = ({ orgId }: Props) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<SelectedIcon>("call");

  return (
    <div>
      <div className="flex items-center justify-between border-b border-slate-200 px-5">
        <nav className="flex -mb-px">
          {TABS.map(({ key, label, Icon }) => {
            const active = selected === key;
            return (
              <button
                key={key}
                type="button"
                onClick={() => setSelected(key)}
                className={cn(
                  "inline-flex items-center gap-2 px-3 py-3 text-sm font-medium border-b-2 transition-colors",
                  active
                    ? "border-vg-blue text-vg-blue"
                    : "border-transparent text-slate-500 hover:text-slate-700"
                )}
              >
                <Icon className="w-4 h-4" />
                {label}
              </button>
            );
          })}
        </nav>
        <RegularButton color="Secondary" onClick={() => ""}>
          <span>{t(ADD_BUTTON_LABEL_KEYS[selected])}</span>
        </RegularButton>
      </div>

      <div className="px-5 py-5">
        {selected === "call" && <PhoneNumbersList orgId={orgId} />}
        {selected === "building" && <AddressesList orgId={orgId} />}
        {selected === "appointment" && <Appointments orgId={orgId} />}
      </div>
    </div>
  );
};

export default DetailSelector;
